<template>
  <div class="menu" :class="[{active: isActive}]" ref="menuRef">
    <img class="menu__close" src="@icons/crossIcon.svg" alt="cross" @click="closeModal()">
    <form class="menu__form" @submit.prevent="search">
      <input
          class="menu__form-input"
          :placeholder="t('fields.headerSearch')"
          v-model="searchInput"
      />
    </form>
    <div class="menu__actions" v-if="user">
<!--      <router-link :to="translations.i18nRoute({ name: 'profile-balance' })" class="menu__actions-item" @click="closeModal()">-->
<!--        <img src="@icons/currency.svg" alt="currency">-->
<!--        {{ userBalance }}-->
<!--      </router-link>-->
      <router-link :to="translations.i18nRoute({ name: 'wishlist' })" class="menu__actions-item" @click="closeModal()">
        <el-badge :value="productsInWishlistQuantity">
          <img src="@icons/wishlistIcon.svg" :alt="t('buttons.wishlist')">
        </el-badge>
        {{ t('buttons.wishlist') }}
      </router-link>
      <router-link :to="translations.i18nRoute({ name: 'cart' })" class="menu__actions-item" @click="closeModal()">
        <el-badge :value="productsInCartQuantity">
          <img src="@icons/cartIcon.svg" :alt="t('buttons.cart')">
        </el-badge>
        {{ t('buttons.cart') }}
      </router-link>
      <router-link :to="translations.i18nRoute({ name: 'profile-settings' })" class="menu__actions-item" @click="closeModal()">
        <img src="@icons/userIcon.svg" :alt="t('profile.title')">
        {{ t('profile.title') }}
      </router-link>
    </div>
    <div v-else>
      <router-link  :to="translations.i18nRoute({ name: 'login' })" class="menu__auth" @click="closeModal()">
        <img src="@icons/userIcon.svg" alt="user">
        <p>{{ t('header.Sign-in') }}</p>
      </router-link>
      <router-link  :to="translations.i18nRoute({ name: 'register' })" class="menu__auth" @click="closeModal()">
        <img src="@icons/userIcon.svg" alt="user">
        <p>{{ t('header.Sign-up') }}</p>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {computed, ref} from "vue";
import {useAuthStore} from "@/stores/auth.js";
import translations from "@/core/helpers/translations.js";
import {useCartStore} from "@/stores/cart.js";
import {useWishlistStore} from "@/stores/wishlist.js";
import {onClickOutside} from "@vueuse/core";
import {useRouter} from "vue-router";

const {t} = useI18n()
const router = useRouter()
const authStore = useAuthStore()
const cartStore = useCartStore()
const wishlistStore = useWishlistStore()

const props = defineProps({
  isActive: Boolean,
  categories: Array,
})
const emit = defineEmits(['close-modal'])

const closeModal = () => {
  emit('close-modal');
}

const menuRef = ref(null)
onClickOutside(menuRef, () => closeModal())

const userBalance = computed(() => {
  return authStore.user ? authStore.user.balance.amount : 0
})

const productsInCartQuantity = computed(() => {
  return cartStore.currentOrder.orderProducts ? cartStore.currentOrder.orderProducts.edges.length : 0
})
const productsInWishlistQuantity = computed(() => {
  return wishlistStore.wishlist.products ? wishlistStore.wishlist.products.edges.length : 0
})

const user = computed(() => {
  return authStore.user
})

const searchInput = ref('')
const search = () => {
  router.push({
    name: 'search',
    params: {
      searchQuery: searchInput.value,
      locale: localStorage.getItem('digitgiftcode-user-locale') || 'en-gb'
    }
  })
}
</script>

<style lang="scss" scoped>
.menu {
  cursor: default;
  display: none;
  position: fixed;
  z-index: 2;
  top: 0;
  right: 0;
  width: 300px;
  height: 100vh;
  background-color: #ffffff;
  padding: 20px;
  visibility: hidden;
  transform: translateX(100%);
  transition: transform 0.3s, visibility 0s 0.3s;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  border-left: 1px solid black;
  box-shadow: 0 4px 11.6px 0 rgba(0, 0, 0, 0.20);

  &.active {
    visibility: visible;
    transform: translateX(0);
    transition: transform 0.3s;
  }

  &__close {
    align-self: flex-end;
    width: 40px;
  }

  &__form {
    width: 100%;

    &-input {
      border: black solid 1px;
      width: 100%;
      border-radius: 10px;
      background-color: #ffffff;
      padding: 15px 10px 15px 40px;
      background-image: url(@icons/searchIcon.svg);
      background-repeat: no-repeat;
      background-position: left 13px top 50%;

      color: #666;
      font-size: 10px;
      line-height: 16px;
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;

    &-item {
      cursor: pointer;
      padding-bottom: 15px;
      border-bottom: 1px solid #D9D9D9;
      display: flex;
      align-items: center;
      gap: 5px;
      transition: 0.2s;

      color: #666;
      font-weight: 700;
      line-height: 18px;

      @include hover {
        color: #3b3b3b;
      }

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }
    }
  }

  &__auth {
    display: flex;
    align-items: center;
    gap: 5px;

    & p {
      transition: 0.2s;
      color: #3b3b3b;
      font-size: 16px;
      font-weight: 700;
      line-height: 18px;
    }

    @include hover {
      & p {
        color: #3b3b3b;
      }
    }
  }
}

@media (max-width: 1100px) {
  .menu {
    display: flex;
  }
}
</style>